import debounce from 'lodash.debounce'

const { ajaxurl } = window.path //eslint-disable-line

function createFormData(formData, key, data) {
  if (data === Object(data) || Array.isArray(data)) {
    for (const i in data) {
      //eslint-disable-line
      createFormData(formData, `${key}[${i}]`, data[i])
    }
  } else {
    formData.append(key, data)
  }
}

class CartUpdater {
  constructor() {
    this.totalBlock = document.querySelector('.c-cart__total')
    this.init()
  }

  init() {
    // console.log('init cart init')
    this.refreshEventListeners()
    window.emitter.on('cart-updated', this.refreshEventListeners.bind(this))
  }

  refreshEventListeners() {
    // console.log('refreshEventListeners')
    this.items = [...document.querySelectorAll('.c-cart__item')]

    // console.log(this.items)
    const debouncedFetch = debounce(this.fetch, 1000)
    this.items.forEach((item) => {
      const input = item.querySelector('input[type=number]')
      input.addEventListener('change', debouncedFetch.bind(this))
    })

    // console.log(this.items)
  }

  fetch() {
    this.getCart()
    this.totalBlock.style.opacity = 0.5

    // console.log(this.updatedCart)

    const data = new FormData()
    data.append('action', 'pf_cart_update')
    createFormData(data, 'items', this.updatedCart)

    console.log('Updated cart, sending action to pf cart update', this.updatedCart)
    // return

    fetch(ajaxurl, {
      method: 'POST',
      body: data,
    })
      .then((response) => response.json())
      .then((payload) => {
        if (payload) {
          console.log(payload)
          window.emitter.emit('update-cart', payload)
          this.totalBlock.style.opacity = 1
        }
      })
      .catch((error) => {
        console.error('Error:', error) //eslint-disable-line
      })
  }

  getCart() {
    this.updatedCart = []
    this.items.forEach((item) => {
      const { productId, variationId } = item.querySelector('.js-remove-from-cart').dataset
      const { value: quantity } = item.querySelector('input[type=number]')
      this.updatedCart.push({
        productId,
        variationId,
        quantity,
      })
    })
  }
}

new CartUpdater()
